import { RoleCodeLayer } from '../interfaces/rbac.interface';
import { RoleLayer, UserRole } from '../enums/role.enum';

export type AccountLevelRoleCode = UserRole.ACCOUNT_ADMIN | UserRole.QR_MANAGER;

export function hasAccountAdminRole(
  roles: readonly RoleCodeLayer[] | null | undefined
): boolean {
  return roles?.some(
    (roleItem) =>
      roleItem.layer === RoleLayer.ACCOUNT &&
      roleItem.code === UserRole.ACCOUNT_ADMIN
  ) ?? false;
}

export function getSelectedAccountRoleCode(
  roles: readonly RoleCodeLayer[] | null | undefined
): AccountLevelRoleCode | null {
  const accountRole = roles?.find(
    (roleItem) =>
      roleItem.layer === RoleLayer.ACCOUNT &&
      (roleItem.code === UserRole.ACCOUNT_ADMIN || roleItem.code === UserRole.QR_MANAGER)
  );

  if (!accountRole) {
    return null;
  }

  return accountRole.code as AccountLevelRoleCode;
}

export function getSelectedAccountRole<T extends { code: UserRole; layer: RoleLayer }>(
  roles: readonly RoleCodeLayer[] | null | undefined,
  catalog: readonly T[]
): T | null {
  const selectedCode = getSelectedAccountRoleCode(roles);

  if (!selectedCode) {
    return null;
  }

  return catalog.find((roleItem) => roleItem.layer === RoleLayer.ACCOUNT && roleItem.code === selectedCode) ?? null;
}

export function filterAssignableDomainRolesFromCatalog<T extends { layer: RoleLayer }>(
  catalog: readonly T[]
): T[] {
  return catalog.filter((roleItem) => roleItem.layer === RoleLayer.DOMAIN);
}
